<template>
<div>
<div class="syn-content">
  <mu-row gutter>
    <mu-col width="100" tablet="50" desktop="50">
      <mu-paper :zDepth="1" rounded >
        <div class="card-toolbar color-black" style="background-color: #ffc107;">
          <span class="card-toolbar-title" style="color: rgba(0, 0, 0, 0.87);">
            CA par département
          </span>
          <span><mu-icon value="cloud_download"/></span>
        </div>
        <div style="width:100%; padding:15px;">
          <mu-row gutter>
              <mu-col width="100" tablet="50" desktop="50">
                <mu-date-picker hintText="Date" :fullWidth="true" container="inline" 
                    v-model="caDeptXls.vou_date_start" 
                    okLabel="Ok" cancelLabel="Annuler" autoOk
                    format="DD/MM/YYYY" :dateTimeFormat="enDateFormat" />
              </mu-col>
              <mu-col width="100" tablet="50" desktop="50">
                <mu-date-picker hintText="Date" :fullWidth="true"  container="inline"
                    v-model="caDeptXls.vou_date_end" 
                    okLabel="Ok" cancelLabel="Annuler" autoOk
                    format="DD/MM/YYYY" :dateTimeFormat="enDateFormat" />
              </mu-col>
          </mu-row>
          <div style="text-align: right; padding:5px; ">
              <mu-raised-button 
                  label="Télécharger" 
                  backgroundColor="#8bc34a"
                  @click="getCaDeptXls()"/>
          </div>
        </div>
      </mu-paper>
    </mu-col>
    <mu-col width="100" tablet="50" desktop="50">
      <mu-paper :zDepth="1" rounded >
        <div class="card-toolbar color-black" style="background-color: #c8e6c9;">
          <span class="card-toolbar-title" style="color: rgba(0, 0, 0, 0.87);">
            Listing excel (recep)
          </span>
          <span><mu-icon value="cloud_download"/></span>
        </div>
        <div style="width:100%; padding:15px;">
          <mu-row gutter>
              <mu-col width="100" tablet="50" desktop="50">
                <mu-date-picker hintText="Date" :fullWidth="true" container="inline" 
                    v-model="listXls.vou_date_start" 
                    okLabel="Ok" cancelLabel="Annuler" autoOk
                    format="DD/MM/YYYY" :dateTimeFormat="enDateFormat" />
              </mu-col>
              <mu-col width="100" tablet="50" desktop="50">
                <mu-date-picker hintText="Date" :fullWidth="true"  container="inline"
                    v-model="listXls.vou_date_end" 
                    okLabel="Ok" cancelLabel="Annuler" autoOk
                    format="DD/MM/YYYY" :dateTimeFormat="enDateFormat" :minDate="minDate" />
              </mu-col>
          </mu-row>
          <div style="text-align: right; padding:5px; ">
              <mu-raised-button 
                  label="Télécharger" 
                  backgroundColor="#8bc34a"
                  @click="getListXls()"/>
          </div>
        </div>
      </mu-paper>
    </mu-col>
    <mu-col width="100" tablet="50" desktop="50" class="mt8">
      <mu-paper :zDepth="1" rounded >
        <div class="card-toolbar color-black" style="background-color: #e1bee7;">
          <span class="card-toolbar-title" style="color: rgba(0, 0, 0, 0.87);">
            Rapport de regroupement
          </span>
          <span><mu-icon value="cloud_download"></mu-icon></span>
        </div>
        <div style="width:100%; padding:15px;">
          <mu-row gutter>
            <mu-col width="100" tablet="100" desktop="100">
                <mu-auto-complete label="Client" labelFloat 
                      @keyup.native.enter="afterCusGroup()"
                      v-model="customer.nom" :fullWidth="cusFull"
                      @input="comInput" :dataSource="comSource" @select="comSelect" filter="noFilter">
                </mu-auto-complete>
            </mu-col>
            <mu-col width="100" tablet="50" desktop="50">
                <mu-date-picker hintText="Date" :fullWidth="true" container="inline" 
                    v-model="groupXls.vou_date_start" 
                    okLabel="Ok" cancelLabel="Annuler" autoOk
                    format="DD/MM/YYYY" :dateTimeFormat="enDateFormat"></mu-date-picker>
            </mu-col>
            <mu-col width="100" tablet="50" desktop="50">
                <mu-date-picker hintText="Date" :fullWidth="true"  container="inline"
                    v-model="groupXls.vou_date_end" 
                    okLabel="Ok" cancelLabel="Annuler" autoOk
                    format="DD/MM/YYYY" :dateTimeFormat="enDateFormat"></mu-date-picker>
            </mu-col>
            <mu-col width="100" tablet="100" desktop="100">
                <mu-checkbox v-model="groupXls.formatTyp" :label="grpLabel" @input="fTypLabel()"></mu-checkbox>
            </mu-col>
          </mu-row>
          <div style="text-align: right; padding:5px; ">
              <mu-raised-button 
                :disabled="grpEnable"
                label="Télécharger" 
                backgroundColor="#8bc34a"
                @click="getGroupXls()"/>
          </div>
        </div>
      </mu-paper>
    </mu-col>
  </mu-row>
</div>
</div>
</template>


<script>
import {col, row} from 'muse-components/grid'
import {list, listItem}  from 'muse-components/list'
// plugin
import dateLocale from '../plugin/dateLocale';

export default {
  name: 'report',
  data () {
    return {
        autoProcess: false,
        saveProgress: false,
        enDateFormat: dateLocale,
        comSource: [{text:'', value:''}],  // Liste auto-complete
        cusGrpChange: false,
        cusLoad: true,
        cusFull: true,
        customer : { rowid: 0, nom: '' },
        listXls: {
            vou_date_start: this.getToday(),
            vou_date_end: this.getToday(),
            _path:'report/1/vouchxls'
        },
        groupXls: {
            cus_id: 0,
            soc_parent_id: 0,
            vou_date_start: this.getToday(),
            vou_date_end: this.getToday(),
            formatTyp: false,
            _path:'cusreport/1/groupxls'
        },
        caDeptXls: {
            vou_date_start: this.getToday(),
            vou_date_end: this.getToday(),
            _path:'report/1/cadepxls'
        },
        grpLabel: 'Rapport / calcul remise'
    }
  },
  computed: {
    minDate:function(){
        return this.listXls.vou_date_start
    },
    grpEnable: function(){
        if( this.groupXls.cus_id ){
            return false
        } else {
            return true
        }
    }
  },
  methods: {
      getToday(date){
          var today = date || new Date();
          var dd    = today.getDate();
          var mm    = today.getMonth()+1; //January is 0!
          var yyyy  = today.getFullYear();
          if(dd<10){ dd='0'+dd; }
          if(mm<10){ mm='0'+mm; }
          return dd+'/'+mm+'/'+yyyy
      },
      getListXls(){
        this.saveProgress = true
        window.axios.get( '/', {
            params: this.listXls, //this.listXls,
            responseType:"blob"
        })
        .then( (response) => {
            this.saveProgress = false
            this.$download(response.data, "listing.xlsx", "application/vnd.ms-excel;charset=charset=utf-8")
        })
      },
      getCaDeptXls(){
        this.saveProgress = true
        window.axios.get( '/', {
            params: this.caDeptXls, //this.listXls,
            responseType:"blob"
        })
        .then( (response) => {
            this.saveProgress = false
            this.$download(response.data, "ca_dept.xlsx", "application/vnd.ms-excel;charset=charset=utf-8")
        })
      },
      getGroupXls(){
        this.saveProgress = true
        window.axios.get( '/', {
            params: this.groupXls,
            responseType:"blob"
        })
        .then( (response) => {
            this.saveProgress = false
            this.$download(response.data, "listing.xlsx", "application/vnd.ms-excel;charset=charset=utf-8")
        })
      },
      afterCusGroup(){
          if ( this.comSource[0].value !== undefined && this.cusGrpChange === true ) {
              this.comSelect( { item:this.comSource[0].item }, 1)
          } else if( this.vouch.deszip != '' ){
              this.handleNext()
          }
      },
      comInput (val) {
          if( this.autoProcess ){
              clearTimeout(this.autoProcess)
          }
          if( val.length > 1 && this.cusLoad == true ){
              this.cusGrpChange = true
              this.autoProcess = setTimeout( () => {
                  window.axios.post( '/', { _method:'GET', _path:'societe', nom: val } )
                  .then( (response) => {
                      let data = []
                      let cus, key
                      for (key = 0; (cus = response.data[key]) !== undefined; key++) {
                          data[key] = { text: cus.nom, value: cus.rowid, item: cus }
                      }
                      this.comSource = data
                  })
              }, 800)
          } else {
              return false
          }
      },
      comSelect (obj, val) {
        var item = obj.item
        this.groupXls.soc_parent_id = item.parent
        this.groupXls.cus_id = item.rowid
        this.customer.rowid  = item.rowid
        this.customer.nom    = item.nom
        this.cusGrpChange    = false
        this.cusLoad         = false
        setTimeout( () => {
            this.cusLoad = true
        }, 100);
      },
      fTypLabel(val){
          if( this.groupXls.formatTyp ){
              this.grpLabel = 'Rapport client'
          } else {
              this.grpLabel = 'Rapport / calcul remise'
          }
      }
  },
  mounted:function (){
    var date = new Date();
    var firstDay = new Date(date.getFullYear(), date.getMonth() - 1, 1);
    var lastDay = new Date(date.getFullYear(), date.getMonth(), 0);
    this.groupXls.vou_date_start = this.getToday(firstDay)
    this.groupXls.vou_date_end   = this.getToday(lastDay)
    
    this.caDeptXls.vou_date_start = this.getToday(firstDay)
    this.caDeptXls.vou_date_end   = this.getToday(lastDay)

  },
  components: {
    'mu-list': list,
    'mu-list-item' : listItem,
    'mu-row': row,
    'mu-col': col
  }
}
</script>

<style lang="less">
.mt8 {
  margin-top: 8px;
}
</style>


// WEBPACK FOOTER //
// Report.vue?142f8f5c